import { useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { onClickOutside } from 'lib/customHooks'
import { calculationFormatOptions } from 'apps/builder/lib/utils'
import { builderTypeSelector } from 'apps/builder/store/selectors'

export const CalculationFormatDropdown = ({ guid, style, mask, type }) => {
  const builderType = useSelector(builderTypeSelector)
  const dispatch = useDispatch()
  const formatControlRef = useRef(null)

  const calcSettings = {
    formatOptions: calculationFormatOptions(builderType),
    decimalOptions: [
      { label: '1', value: '0' },
      { label: '1.0', value: '1' },
      { label: '1.00', value: '2' },
      { label: '1.000', value: '3' },
      { label: '1.0000', value: '4' },
      { label: '1.00000', value: '5' },
      { label: '1.000000', value: '6' },
    ],
    getFormatOption: function (style) {
      return (
        this.formatOptions.find(format => format.value === style) ||
        this.formatOptions[0]
      )
    },
    getDecimalOption: function (mask) {
      return (
        this.decimalOptions.find(format => format.value == mask) ||
        this.decimalOptions[2]
      )
    },
  }

  const selectedOption = !style
    ? calcSettings.getDecimalOption(mask).label
    : calcSettings.getFormatOption(style).label

  const [toggleDropdown, setToggle] = useState(false)

  const update = values => {
    dispatch(
      updateEntry({
        type,
        guid,
        ...values,
      })
    )
  }
  onClickOutside(formatControlRef, () => setToggle(false))
  return (
    <div
      className="calculation--format--dropdown--wrapper"
      ref={formatControlRef}
    >
      <div className="format--dropdown--wrapper">
        <div
          className="results--wrapper"
          onClick={() => {
            setToggle(!toggleDropdown)
          }}
        >
          Format
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
        <div className="calculation--result">{selectedOption}</div>
        {toggleDropdown && (
          <div className="fields-library--list foundry--surface format--list--wrapper">
            {calcSettings.formatOptions.map(({ label, value }, i) => (
              <div
                className={`field--option fields-library--option format--option`}
                key={i}
                onClick={() => {
                  if (value) {
                    update({ style: value, mask: 0 })
                    setToggle(!toggleDropdown)
                  }
                }}
              >
                {label}
                {value == 0 && <FontAwesomeIcon icon={faChevronRight} />}
              </div>
            ))}
            <div className="fields-library--list foundry--surface format--decimal--list--wrapper">
              {calcSettings.decimalOptions.map(({ label, value }, i) => (
                <div
                  className={`field--option fields-library--option format--option`}
                  key={`decimal-${i}`}
                  onClick={() => {
                    update({ style: 0, mask: value })
                    setToggle(!toggleDropdown)
                  }}
                >
                  {label}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
